import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
};

const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const formatDateToCustomerService = (dateString, includeTime = false) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    
    if (!includeTime) {
        return `${day} ${month} ${year}`;
    }
    const timeOptions = { 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true 
    };
    const timeString = date.toLocaleTimeString('en-AU', timeOptions);
    const formattedTimeString = timeString.replace(/\b(am|pm)\b/g, (match) => match.toUpperCase());
    
    return `${day} ${month} ${year}, ${formattedTimeString}`;
};

const formatDateTimeToCustomerService = (dateString) => {
    return formatDateToCustomerService(dateString, true);
};

const getDateRange1Year = () => {
    return {
        from: dayjs()
            .tz('Australia/Sydney')
            .subtract(1, 'year'),
        to: dayjs()
            .tz('Australia/Sydney')
    }
}

export { formatDate, formatDateTime, formatDateTimeToCustomerService, formatDateToCustomerService, getDateRange1Year };
